import { api } from './api';

const campURL = '/camp';

export const campApi = api.injectEndpoints({
  endpoints: builder => ({
    getAllCamps: builder.query({
      query: () => campURL,
      providesTags: ['Camp'],
    }),
    getCampsByUser: builder.query({
      query: userId => `${campURL}/user/${userId}`,
      providesTags: ['Camp'],
    }),
    createCamp: builder.mutation({
      query: body => ({
        url: campURL,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['Camp'],
    }),
    getCampById: builder.query({
      query: id => `${campURL}/${id}`,
    }),
    updateCamp: builder.mutation({
      query: ({ _id, ...body }) => ({
        url: `${campURL}/${_id}`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['Camp'],
    }),
    getAllActiveCamps: builder.query({
      query: (userId) => `${campURL}/user/${userId}`,
      transformResponse: (camps) => camps.filter((c) => c.status === true),
      providesTags: ['Camp'],
    }),
    getEventsByCampController: builder.query({
      query: ({ id }) => `${campURL}/${id}/events`,
    }),
    publishGrades: builder.mutation({
      query: ({ _id, publish }) => ({
        url: `${campURL}/${_id}/publish-grades`,
        method: 'PATCH',
        body: { publish },
      }),
      invalidatesTags: ['Camp'],
    }),
    syncGrades: builder.mutation({
      query: ({ _id }) => ({
        url: `${campURL}/${_id}/sync-grades`,
        method: 'PATCH',
      }),
      invalidatesTags: ['Camp'],
    }),
  }),
});

export const {
  useGetAllCampsQuery,
  useGetCampsByUserQuery,
  useCreateCampMutation,
  useGetCampByIdQuery,
  useUpdateCampMutation,
  useGetAllActiveCampsQuery,
  useGetEventsByCampControllerQuery,
  usePublishGradesMutation,
  useSyncGradesMutation,
} = campApi;
